import { Button, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createCandidacy } from '../../commons/redux/actions/user.actions'
import { checkFiles, checkValue } from '../../commons/utils'
import './style.css'
export default function Recrutment() {
  const [user, setUser] = useState({})
  const [file, setFile] = useState()
  const [load, setLoad] = useState(false)
  const [err, setErr] = useState()
  const toast = useToast()
  const [other, setOther] = useState(false)
  const { response } = useSelector((state) => state.userReducer)
  const dispatch = useDispatch()
  const handle = (e) => {
    const { value, name, checked } = e.target
    if (value === 'autre') {
      setOther(true)
    } else {
      setOther(false)
    }
    setUser({ ...user, [name]: value })
  }
  console.log(user)
  const handleOther = (e) => {
    const { value, name } = e.target
    setUser({ ...user, [name]: value })
  }

  const handleLng = (e) => {
    const { name, checked } = e.target
    let lng = []
    if (checked) {
      lng[lng.length + 1] = lng.push(name)
      setUser({ ...user, lng: lng })
      console.log(lng)
    } else if (!checked) {
      lng[name] = ''
      setUser({ ...user, lng: lng })
    }
    console.log(user)
  }

  const handleDoc = (e) => {
    const newFile = e.target.files[0]
    setFile(newFile)
    const { name } = newFile
    const rp = checkFiles(name)
    if (!rp) {
      setErr(true)
      return
    }
    setErr(false)
  }

  const setApplication = async () => {
    if (!file) {
      toast({
        title: 'Documents manquants',
        description: `Vous devez obligatoirement fournir un document`,
        status: 'info',
        duration: 8000,
        isClosable: true,
      })
      return
    }
    if (user?.old > 60 || user?.old < 18 || user?.old === '' || !user?.old) {
      console.log(typeof user.old)
      toast({
        title: 'Age non conforme',
        description: `Vous devez avoir au moins 18 ans  `,
        status: 'info',
        duration: 8000,
        isClosable: true,
      })
      return
    }
    if (!user?.skill) {
      toast({
        title: 'Donnees manquantes',
        description: `Vous devez avoir une competence `,
        status: 'info',
        duration: 8000,
        isClosable: true,
      })
      return
    }
    setLoad(true)
    try {
      const data = new FormData()
      data.append('some_document', file)
      data.append('name', user?.name)
      data.append('tel', user?.tel)
      data.append('town', user?.town)
      data.append('type', user?.type)
      data.append('old', user?.old)
      data.append('language', user?.language)
      data.append('district', user?.district)
      data.append('country', user?.country)
      data.append('skill', user?.skill)
      await dispatch(createCandidacy(data))
    } catch (error) {
      setLoad(false)
      console.log(error)
    }
  }
  useEffect(() => {
    if (response.status === 202) {
      setLoad(false)
      toast({
        title: 'Candidature envoyee !',
        description: `Bravo ${user?.name} votre candidature a ete envoyee`,
        status: 'success',
        duration: 9000,
        isClosable: true,
      })
    }
    if (response.statusCode === 400) {
      setLoad(false)
      toast({
        title: 'Champs manquants !',
        description: `Veuillez remplir tous les champs !!`,
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }, [response, toast, user.name])

  return (
    <div>
      <div className="row   recrutment mx-auto">
        <div className="col-lg-5  bg-white mx-auto my-3 ">
          <div className="nous text-center mx-auto">
            <h2>Rejoignez-nous.</h2>
            <h3 className="text-black text-sm font-bold">
              Nous voulons des talents !
            </h3>
          </div>
          <form encType="multipart/form-data" className="form_command">
            <fieldset className="border-none">
              <legend className="mb-0 mt-2 text-sm">Personnalité</legend>
              <div>
                <label htmlFor="" className="text-sm">
                  Votre nom
                </label>
                <input
                  type="text"
                  name="name"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="" className="text-sm">
                  Votre age
                </label>
                <input
                  type="number"
                  name="old"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="" className="text-sm">
                  Votre sexe
                </label>
                <select
                  name="type"
                  onChange={handle}
                  id="type"
                  className="appearance-none form-select border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                >
                  <option value="fem">Feminin</option>
                  <option value="masc">Masculin</option>
                </select>
              </div>

              <div>
                <label className="  text-sm">Téléphone</label>
                <input
                  type="text"
                  name="tel"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
              <div className="form-group flex-col mt-2">
                <label htmlFor="lang" className="  d-block text-sm">
                  Langue parlee(s){' '}
                </label>
                <div>
                  {' '}
                  <input
                    type="checkbox"
                    name="Francais"
                    onClick={handleLng}
                    id="fr"
                  />
                  <label htmlFor="" className="text-sm   mx-2">
                    Francais
                  </label>
                </div>

                <div>
                  {' '}
                  <input
                    type="checkbox"
                    onClick={handleLng}
                    name="Wolof"
                    id="wf"
                  />
                  <label htmlFor="" className="text-sm   mx-2">
                    Wolof{' '}
                  </label>
                </div>
                <div>
                  {' '}
                  <input
                    type="checkbox"
                    id="ar"
                    name="Arabe"
                    onClick={handleLng}
                    className="form-checkbox rounded text-pink-500"
                  />
                  <label htmlFor="" className="text-sm   mx-2">
                    Arabe{' '}
                  </label>
                </div>

                <div>
                  {' '}
                  <input
                    type="checkbox"
                    name="Anglais"
                    onClick={handleLng}
                    id="an"
                  />
                  <label htmlFor="" className="text-sm   mx-2">
                    Anglais{' '}
                  </label>
                </div>
              </div>
            </fieldset>

            <fieldset className="border-none">
              <legend className="mb-0 mt-2 text-sm">Adresse</legend>
              <div>
                <label htmlFor="" className="  text-sm">
                  Pays{' '}
                </label>
                <input
                  type="text"
                  name="country"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
              <div>
                <label htmlFor="" className="  text-sm">
                  Ville{' '}
                </label>
                <input
                  type="text"
                  name="town"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>

              <div>
                <label htmlFor="" className="  text-sm">
                  Quartier{' '}
                </label>
                <input
                  type="text"
                  name="district"
                  onChange={handle}
                  className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                />
              </div>
            </fieldset>
            <fieldset className="border-none">
              <legend className="mb-0 mt-2 text-sm">Compétence</legend>
              <div className="form-group">
                <label htmlFor="skill" className="  text-sm">
                  Je suis
                </label>
                <select
                  name="skill"
                  onChange={handle}
                  className="appearance-none form-select border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  id="jesuis"
                >
                  <option value="nounou">Nounou</option>
                  <option value="plombier">Plombier</option>
                  <option value="electricien">Electricien</option>
                  <option value="macon">Macon</option>
                  <option value="peintre">Peintre</option>
                  <option value="depanneur de telephone">
                    Depanneur telephone
                  </option>
                  <option value="depanneur d'ordinateur">
                    Depanneur ordinateur
                  </option>
                  <option value="frigoriste">Frigoriste</option>
                  <option value="menuisier">Menuisier</option>
                  <option value="cuisinier">Cuisinier</option>
                  <option value="major d'homme">Majord'Homme</option>
                  <option value="menagere">Menagere</option>
                  <option value="chauffeur">Chauffeur</option>
                  <option value="menagere">Menagere</option>
                  <option value="lessiveuse">Lessiveuse</option>
                  <option value="tache generique">Tache generique</option>
                  <option value="autre">Autre</option>
                </select>
              </div>
              {(other || user.skill === 'autre') && (
                <div className="mt-2">
                  <label htmlFor="skill" className="  text-sm">
                    Indiquez votre competence ici{' '}
                  </label>
                  <input
                    type="text"
                    name="skill"
                    required
                    onChange={handleOther}
                    className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
              )}
            </fieldset>
            <legend className="mb-0 mt-2 text-sm">Médias</legend>

            <div>
              <label htmlFor="cv" className=" text-sm">
                Passeport/CNI
              </label>
              <input
                type="file"
                name="some_document"
                onChange={(e) => handleDoc(e)}
                className="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 text-gray-700 focus:outline-none focus:bg-white"
              />
              {err && (
                <p className="help-text text-sm text-red-500">
                  * Fichiers non autorises
                </p>
              )}
            </div>

            <div className="my-2">
              {load ? (
                <Button
                  isLoading={true}
                  loadingText={'Patientez...'}
                  variant={'solid'}
                  className="w-100"
                  colorScheme={'red'}
                >
                  {' '}
                </Button>
              ) : (
                <Button
                  colorScheme={'orange'}
                  height="40px"
                  textAlign={'center'}
                  textColor
                  type="button"
                  onClick={setApplication}
                  className="btn btn-block focus:shadow-none bg-gray-100 font-bold w-100 text-2xl"
                >
                  Postuler{' '}
                </Button>
              )}
            </div>
          </form>
        </div>
        <div className="col-lg-5 d-none d-lg-block my-3">
          <img src={'./images/join.svg'} className="" alt="" srcset="" />
        </div>
      </div>
    </div>
  )
}
